const GIT_REPO = "https://github.com/codebymurtaza/Digital-Clock";
const YOUTUBE_BASE = "https://youtu.be/";
export default {
  youtubeVideos: [
    {
      title: "HOW TO CREATE A  DIGITAL CLOCK",
      id: "pPMO5g5aTaE",
    },
    {
      title: "How to make a pop-up page using html CSS and JavaScript",
      id: "I4uqXKwSBqM",
    },
    {
      title: "How to create an Image Hover project",
      id: "Op7sI9ETays",
    },
    {
      title: "Working with Hooks in reactJs",
      id: "6G6pp5yYUKg",
    },
    {
      title: "Greek in a different views",
      id: "00YSBqtS_70",
    },
    {
      title: "How to use WorldCom?",
      id: "ZiwdEA9Tjp8",
    },
    {
      title: "How to download Heidisql on windows 10? just in 2 minutes!",
      id: "7P_mSc9KOgA",
    },
  ],
};
